// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4Axcp","right":"styles_right__1ghI6"};